export const NO_DATA_LABEL = "Brak danych";

export const capitalize = (text: string): string => (text.length > 0 ? text.charAt(0).toUpperCase() + text.slice(1) : text);
export const NO_DATA_LABEL = "Brak danych";

export const capitalize = (text: string): string => (text.length > 0 ? text.charAt(0).toUpperCase() + text.slice(1) : text);
